import { render, staticRenderFns } from "./warningDlg.vue?vue&type=template&id=83bd6ba0"
import script from "./warningDlg.vue?vue&type=script&lang=js"
export * from "./warningDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports